import '@justgiving/totaliser/src/Totaliser.scss';

import React, { FunctionComponent } from 'react';

import { Totaliser, LondonEye } from '@justgiving/totaliser';

import { gql } from '@apollo/client';

import { TotaliserWrapperFragment } from '../../../types/__generated__';
import usePageQuery, { buildQuery } from '../../hooks/usePageQuery';
import TotaliserWrapperSkeleton from '../TotaliserWrapperSkeleton/TotaliserWrapperSkeleton';

import './TotaliserWrapper.scss';
import { useBasePageQuery } from '../../hooks';

const FRAGMENT = buildQuery(gql`
  fragment TotaliserWrapper on Page {
    id
    targetWithCurrency {
      value
    }
    branding {
      primaryColor
    }
    reason {
      icon
    }
    relationships {
      events(first: 1) {
        nodes {
          legacyId
        }
      }
    }
  }
`);

const TotaliserWrapper: FunctionComponent = () => {
  const { loading, error, refetch, data = null } = usePageQuery<
    TotaliserWrapperFragment
  >(FRAGMENT, {
    notifyOnNetworkStatusChange: true,
  });
  const { data: basePageData } = useBasePageQuery();

  if (loading) {
    return <TotaliserWrapperSkeleton animated displayRefreshButton={false} />;
  }

  if (error) {
    return <TotaliserWrapperSkeleton onRefresh={refetch} />;
  }

  if (!data || !basePageData) {
    return null;
  }

  const target = data.targetWithCurrency?.value;

  if (!target || target === 0) {
    return null;
  }

  const totalAmount =
    basePageData.page?.donationSummary?.totalAmount?.value ?? 0;
  const percentageOfTarget = (totalAmount / target) * 100;

  const eventsRelationship = data.relationships?.events?.nodes[0];
  // LLHM 2023 && 2024
  const isLLHM =
    eventsRelationship?.legacyId === '7444724' ||
    eventsRelationship?.legacyId === '8144388';

  return !isLLHM ? (
    <Totaliser
      className="jg-pages-totaliser-main"
      percent={percentageOfTarget}
      size="auto"
      isAnimated
    />
  ) : (
    <Totaliser
      className="jg-pages-totaliser-main"
      percent={percentageOfTarget}
      size="auto"
      isAnimated
    >
      <LondonEye />
    </Totaliser>
  );
};

export default TotaliserWrapper;
